export default __webpack_public_path__ + "static/media/1-bicycle-PEN.f06fafc2.jpg";